module.exports = __webpack_public_path__ + "img/1281287693.ddcb53ba.jpg";